export * from './safe-html.pipe';



// WEBPACK FOOTER //
// ./src/app/pipes/safe-html/index.ts